/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EMPTY, Observable, Subject } from 'rxjs';
import { catchError, map, shareReplay, switchMap, tap } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiHotelHotelSellReportChangeObservedPost } from '../fn/change-observed-endpoint/api-hotel-hotel-sell-report-change-observed-post';
import { ApiHotelHotelSellReportChangeObservedPost$Params } from '../fn/change-observed-endpoint/api-hotel-hotel-sell-report-change-observed-post';
import { StatusedBasedResponseInfoResultApiResult } from '../models/statused-based-response-info-result-api-result';

import { environment } from '@environments/environment';
import { Saver, SAVER } from '@donstudio/ds/_tokens';
import { Download, download } from '@donstudio/shared/file-export';
import { Voucher } from '@modules/reports/voucher/model';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class ChangeObservedEndpointService extends BaseService {
  pdf$$: Subject<Voucher>;
  pdf$: Observable<Download>;
  pdfIsLoading$: Observable<boolean>;

  constructor(
    @Inject(SAVER) private save: Saver,
    config: ApiConfiguration,
    http: HttpClient,
    private toastR: ToastrService,
  ) {
    super(config, http);


    this.pdf$$ = new Subject();
    this.pdf$ = this.pdf$$.asObservable().pipe(
      switchMap(({ sellId, voucherNumber }) => {
        return this.getVoucherBySellId(sellId, voucherNumber, true).pipe(
          catchError(() => {
            this.toastR.error('پردازش اطلاعات با خطا رو به رو شد', '', { closeButton: true, positionClass: 'toast-bottom-left', timeOut: 3000 })
            return EMPTY;
          }),
        )
      }),
      shareReplay(),
    );
    this.pdfIsLoading$ = this.pdf$.pipe(
      map(({ state }) => state !== 'DONE')
    )
  }


  /** Path part for operation `apiHotelHotelSellReportChangeObservedPost()` */
  static readonly ApiHotelHotelSellReportChangeObservedPostPath = '/api/hotel/HotelSellReport/ChangeObserved';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelHotelSellReportChangeObservedPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelHotelSellReportChangeObservedPost$Response(params: ApiHotelHotelSellReportChangeObservedPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StatusedBasedResponseInfoResultApiResult>> {
    return apiHotelHotelSellReportChangeObservedPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelHotelSellReportChangeObservedPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelHotelSellReportChangeObservedPost(params: ApiHotelHotelSellReportChangeObservedPost$Params, context?: HttpContext): Observable<StatusedBasedResponseInfoResultApiResult> {
    return this.apiHotelHotelSellReportChangeObservedPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<StatusedBasedResponseInfoResultApiResult>): StatusedBasedResponseInfoResultApiResult => r.body)
    );
  }

  getVoucherBySellId(sellId: number, filename = 'report', showBuyer = false) {
    return this.http.post(`${environment.apiUrl}/api/hotel/getVoucherBySellId`,
      {
        sellId,
        showBuyer
      },
      {
        headers: {
          accept: 'octet-stream/pdf'
        },
        reportProgress: true,
        observe: 'events',
        responseType: 'blob'
      }
    ).pipe(
      tap((res) => {
        if ('headers' in res) {
          filename = decodeURIComponent(res.headers.get('content-disposition')?.split("''").pop()!);
        }
      }),
      download(blob => {
        return this.save(blob, filename)
      })
    );
  }
}
